/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'

export default flatten({
	isotope: {
		datatable: {
			header: {
				selected: '{numSelected, plural, =0 {ANG - Aucun élément sélectionné} one {ANG - 1 élément sélectionné} other {# ANG - éléments sélectionnés}}'
			},
			footer: {
				elementsPerPage: 'ANG - Éléments par page :',
				pagination: 'ANG - {startIndex, number} - {endIndex, number} sur {total, number}'
			}
		}
	},
	cms: {
		shortcut: 'Clave de entidad',
		errors: {
			required: 'Este campo es obligatorio',
			notFound: 'Modelo no encontrado',
			langueWithErrors: 'Los siguientes idiomas tienen errores : {sections}'
		},
		snackSuccess: 'Tu contenido ha sido actualizado',
		snackError: 'Se produjo un error al actualizar el contenido.',
		entities: {
			tenderbox: 'Modificación de la página de presentación de Tender Box',
			visiteur: 'Modificación de la sección Visitantes',
			presentation: 'Modificación de la sección Presentación',
			contact: 'Modificación de la sección Contacto',
			correspondant: 'Modificación de la sección Corresponsal'
		},
		fields: {
			title: 'Título de la sección *',
			content: 'Contenido de la sección'
		}
	},
	notify: {
		success: 'Contenido guardado',
		error: 'Se ha producido un error'
	},
	btn: {
		save: 'Guardar',
		cancel: 'Cancelar'
	},
	global: {
		messages: {
			accueilFO: 'Se utiliza temporalmente un programa informatico de seguimiento para permitirnos mejorar la herramienta.'
		},
		link: {
			viderFiltre: 'Borrar todos los criterios'
		},
		buttons: {
			rechercher: 'Buscar',
			voirPlus: 'Ver más',
			annuler: 'Cancelar',
			confirm: 'Confirmar',
			compris: 'Comprendido',
			more: 'más información',
			save: 'Guardar',
			save_filter: 'Guardar',
			send: 'Enviar',
			close: 'Cerrar',
			add: 'Añadir',
			validate: 'Validar',
			delete: 'Borrar',
			updateFields: 'Editer campos',
			update: 'Actualizar',
			loginGoogle: 'SIGN IN WITH GOOGLE'
		},
		errors: {
			droitsInsuffisants: 'No tiene los permisos necesarios para acceder a esta página',
			obligatoire: 'Este campo debe ser completado',
			formulaire: 'Debe completar los campos requeridos',
			formatEmail: 'El formato del correo electrónico no es válido',
			amountObligatoire: 'Debe ingresar una moneda',
			amountObligatoireMontant: 'Debe ingresar un importe',
			emptyMessageError: ' '
		},
		yes: 'Si',
		no: 'No',
		workInProgress: 'Funciones en marcha de desarrollo',
		no_results: 'No hay ninguno resultado',
		resultTitle: '{results, plural, one {Resultado} other {Resultados}} de búsqueda ({results, number})',
		tris: {
			pertinence: 'Por relevancia',
			a_z: 'A ⇒ Z',
			z_a: 'Z ⇒ A',
			date_connexion_desc: 'Fecha de la última conexión (de la más reciente a la menos reciente)',
			date_connexion_asc: 'Fecha de la última conexión (de la menos reciente a la más reciente)',
			date_modification_desc: 'Fecha de modificación (de la más reciente a la menos reciente)',
			date_modification_asc: 'Fecha de modificación (de la menos reciente a la más reciente)t',
			like: 'Contenidos preferidos'
		},
		more: {
			export_result: 'Exportar resultados',
			partage_result: 'Compartir la búsqueda',
			ajouter_favoris_result: 'Añadir búsqueda a sus favoritos',
			ajouter_favoris_result_notif_on: 'Agregar búsqueda a sus favoritos con notificación'
		},
		NA: 'No especificado'
	},
	menu: {
		boParametrageMenu: 'CONFIGURACION',
		boPropositionCommercial: 'Propuestas comerciales',
		boSavoirFaire: 'Know-How',
		boReference: 'Referencias',
		boValueList: 'Lista de valores',
		additionalFilters: 'Filtros adicionales',
		boPersonnalisationMenu: 'PERSONALIZACION',
		boBlocPresentation: 'Sección Presentación',
		boBlocVisiteur: 'Sección Visitantes',
		boBlocContact: 'Sección Contacto',
		boBlocCorrespondant: 'Sección Corresponsal',
		returnFo: 'Front office',
		admin: 'Administración',
		accueilMenu: 'Bienvenida',
		contenuMenu: 'CONTENIDOS',
		rechercherContenu: 'Buscar un contenido',
		ajouterContenu: 'Añadir un contenido',
		contribution: 'Mis contribuciones',
		contenuAValider: 'Contenidos a validar',
		contenuAPublier: 'Contenidos a publicar',
		contenuARetirer: 'Contenido a eliminar',
		annuaireMenu: 'DIRECTORIO',
		correspondanceZone: 'Corresponsal',
		demandeAcces: 'Solicitar un acceso como miembro',
		demandeAttente: 'Solicitudes en espera',
		listeUtilisateur: 'Lista de usuarios',
		aideContactMenu: 'Ayuda y contacto',
		presentationTenderBox: 'Presentación de Tender Box',
		formContact: 'Póngase en contacto con el equipo Tender Box'
	},
	favoris: {
		addSearch: {
			success: 'Su búsqueda ha sido añadida a sus favoritos',
			error: 'Su búsqueda no ha podido ser añadida a sus favoritos'
		},
		document: 'Contenidos',
		emptyDocument: 'Todavía no ha guardado contenido en sus favoritos',
		search: 'Búsquedas',
		emptySearch: 'Todavía no ha guardado la búsqueda',
		searchItem: ' Búsqueda guardada el ',
		deleteSearchTitle: 'Eliminación de una búsqueda favorita',
		deleteDocumentTitle: 'Quitar un documento de favoritos',
		deleteSearchDescription: '¿Está seguro de que desea eliminar la búsqueda de sus favoritos?',
		deleteDocumentDescription: '¿Está seguro de que desea eliminar el contenido de sus favoritos?',
		updateSearch: {
			success: 'Su búsqueda no ha sido actualizada',
			error: 'Su búsqueda no ha podido ser actualizada'
		},
		deleteSearch: {
			success: 'Su búsqueda ha sido elimanada con éxito',
			error: 'Su búsqueda no ha podido ser eliminada'
		}
	},
	appBar: {
		menus: {
			monCompte: 'Mi cuenta',
			cookies: '[ANG] Manage my cookies',
			logout: 'Cierre de sesión'
		}
	},
	accueilBo: {
		title: 'Bienvenido a la sección “Administración” de Tender Box'
	},
	translation: {
		inputLabel: 'Traducción',
		button: 'Traducir'
	},
	searchBar: {
		placeHolder: 'Buscar en Tender Box',
		all: 'Todos los contenidos'
	},
	autocompleteMulti: {
		placeHolder: 'Seleccionar'
	},
	constants: {
		request: {
			VALID: 'Validado',
			TO_VALIDATE: 'Por validar'
		},
		profils: {
			VISITEUR: 'Visitante',
			MEMBRE: 'Miembro',
			CORRESPONDANT: 'Corresponsal',
			ADMIN: 'Administrador'
		},
		user_connecte: {
			SEMAINE: 'En la semana',
			MOIS: 'En el mes',
			TRIMESTRE: 'En el trimestre',
			ANNEE: 'En el año'
		}
	},
	users: {
		title: 'Búsqueda',
		listeUsers: 'Lista de usuarios',
		listeDemandes: 'Solicitudes de acceso a validar',
		listeCorrespondants: 'Corresponsal',
		demandeCorrespondant: '¿Desea convertirse en un manager?',
		click: 'Haga clic aquí',
		noResults: 'No hay ninguno usuario que corresponda a su búsqueda',
		search: {
			filterTitle: 'Búsqueda',
			default: 'Indiferente',
			nameLabel: 'Nombre',
			zoneLabel: 'Zona',
			paysLabel: 'País',
			paysOrigineLabel: 'País de origen',
			marcheLabel: 'Mercado',
			segmentLabel: 'Sub-segmento',
			profilLabel: 'Perfil',
			demandeLabel: 'Solicitud',
			connecteLabel: 'Usuarios conectados'
		},
		export: {
			headers: {
				nom: 'ANG - Nom',
				prenom: 'ANG - Prénom',
				zone: 'ANG - Zone',
				statut: 'ANG - Statut',
				dateAjoutStatut: 'ANG - Date d\'ajout du statut',
				dateDerniereConnexion: 'ANG - Date de dernière connexion'
			},
			fileName: 'Export des utilisateurs'
		},
		actions: {
			valid: 'Validar',
			donDroits: 'Dar los derechos de usuario miembro',
			refuse: 'Rechazar',
			delDroits: 'Retirar los derechos como usuario miembro',
			modify: 'Modificar la cuenta de usuario'
		},
		accesRequest: {
			demande: 'Acceso solicitado el:',
			valide: 'Acceso validado el : ',
			refuse: 'Acceso rechazado : ',
			derniereCo: 'Ultima connexión el : ',
			refusAuto: 'Rechazo automatico'
		},
		popin: {
			validation: {
				titlePopin: 'Dar los derechos de usuario miembro',
				messagePopin: 'Confirma usted la atribución de los derechos de usuario miembro a ',
				success: 'La solicitud ha sido validada',
				error: 'Un error se ha producido durante la validación de la solicitud'
			},
			refus: {
				titleRefus: 'Rechazar una solicitud de acceso',
				titleRetire: 'Retirar los derechos de usuario miembro ',
				messageRefus: 'Confirma usted el rechazo de la solicitud de acceso de ',
				messageRetire: 'Confirma usted retirar los derechos de usuario miembro de  ',
				field: 'Justificación *',
				success: 'La solicitud de rechazo ha sido bien validada',
				error: 'Un error se ha producido durante la solicitud de rechazo'
			}
		}
	},
	oss: {
		popinChoixFields: {
			title: 'Selleción de las columnas a motrar ({sizeColumns}/50 columnas maximum)\',',
			sectionChampsAvances: 'Filtros avanzados',
			maxColumnReached: 'No se puede mostrar más de 50 columnas en la tabla'
		},
		tooltip: {
			accesEditList: 'Editar referencias',
			accesViewList: 'Visualización de las referencias de la búsqueda'
		},
		tabDocumentPage: {
			titleEdition: 'Modificación del contenido',
			titleConsultation: 'Visualización del contenido ',
			table: {
				headerTitle: 'Referencias'
			},
			tooltip:{
				fieldNotFoundLang: 'Este campo aún no está rellenado en el idioma seleccionado, para rellenarlo, vaya directamente a la referencia.',
				notEditable: 'Este campo impacta la estructura de la referencia, para modificarlo, vaya directamente a la referencia',
				cantModify: 'Este campo aún no está rellenado en el idioma seleccionado, para rellenarlo, vaya directamente a la referencia.',
				notExist: 'Este campo no esta rellenado en ninguno de los idiomas, para rellenarlo hay que ir directamente a la referencia.'
			},
			snackBar: {
				tabInfo: 'Este modo de edición le permite ver solo las referencias en las cuales tiene derechos de edición.',
				editFieldSucces: 'Cambio tenido en cuenta.',
				editFieldError: 'Edición fallida.',
				tabModificationInfo: 'Este modo de edición le permite ver solo las referencias en las cuales tiene derechos de edición.',
				tabConsultationInfo: 'Este modo de visualización le permite consultar todas las referencias excepto los datos confidenciales representados por un *.'
			}
		},
		actionBar:{
			editColumns: 'Mudar Columnas'
		},
		popin: {
			shareTitle: {
				title: 'Compartir la tabla '
			}
		}
	},
	document: {
		search: {
			collapse: {
				location: 'UBICACIÓN',
				clients: 'CLIENTES',
				activities: 'ACTIVIDADES',
				document: 'TIPO DE DOCUMENTOS',
				additional: 'FILTROS ADICIONALES',
				admin: 'FILTROS ADMINISTRADOR'
			},
			additionalInfos: '¿Busca otro criterio?',
			additionalAddInfos: 'Haga clic aquí para buscar datos específicos',
			adminInfos: 'Haga clic aquí para agregar un filtro de administrador',
			correspondantInfos: 'Haga clic aquí para agregar un filtro de corresponsalía',
			title: 'Buscar en Tender Box',
			titleMesContrib: 'Mis contribuciones',
			titleAValider: 'Contenidos a validar',
			titleAPublier: 'Contenidos a publicar',
			titleARetirer: 'Contenido para eliminar',
			filterTitle: 'Criterios de búsqueda',
			default: 'Indiferente',
			queryPlaceholder: 'Buscar en Tender Box',
			typeContenuLabel: 'Tipos de contenidos',
			typeContenuDefault: 'Todos',
			langueLabel: 'Idiomas',
			zoneLabel: 'Zona',
			marketLabel: 'Market',
			sectorLabel: 'Sector',
			businessSegmentLabel: 'Business segment',
			businessSubSegmentLabel: 'Sub-segmento',
			coreBusinessLabel: 'Core business',
			bidBriefLabel: 'Parte de la propuesta',
			paysLabel: 'País ',
			proposalStatusLabel: 'Estado de la propuesta',
			withAttachmentLabel: 'Archivos adjuntos',
			internalExternalLabel: 'Interno - Externo',
			noResults: 'No hay contenidos correspondientes a su búsqueda',
			correspondant: {
				title: 'FILTROS CORRESPONSAL',
				info: 'Cuando se aplica uno de estos filtros, la búsqueda se llevará a cabo sólo en los contenidos para los que son corresponsal de zona'
			},
			field: {
				noInput: 'Entra una valor',
				noValue: 'Ninguna valor correspondiente'
			},
			advance: {
				title: 'Filtros avanzados',
				addFilter: 'Añadir un filtro',
				description: 'A continuación puede seleccionar los filtros recomendados propuestos según los subsegmentos seleccionados. \n' +
					'Si busca un dato específico diferente, seleccione la opción "<strong>Otros datos</strong>", que le permite buscar un dato específico',
				removeFilter: 'Borrar todos los filtros',
				showOnlyAttachments: 'Solo mostrar los contenidos con archivos adjuntos',
				appliedFilters: 'Filtros aplicados',
				appliedFiltersDescription: 'Aquí los filtros adicionales aplicados aparecerán',
				newFilter: {
					title: 'Nuevo filtro',
					field: {
						searchKey: 'Filtro adicional',
						searchNumber: 'Igual, superior o inferior',
						searchDate: 'Antes de, Después de',
						searchText: 'Contiene, no contiene',
						placeholderText: 'Busca una valor',
						otherData: 'Buscar otros datos',
						dataName: 'Nombre de los datos',
						attachment: 'Solo mostrar los contenidos con archivos adjuntos',
						and: '{lessThan} y {greaterThan}',
						EQUAL: 'Igual a',
						NOT_EQUAL: 'Diferente de',
						SUPERIOR: 'Superior a',
						INFERIOR: 'Inferior a',
						BEFORE: 'Antes',
						AFTER: 'Despues',
						INCLUDE: 'Contiene',
						NOT_INCLUDE: 'No contiene',
						BETWEEN: 'Entre',
						EQUAL_DATE: 'El ',
						errorBetween: 'No puede ser menor que el primer valor',
						errorBetweenDate: 'No puede ser anterior a la primera cita'
					},
					button: 'Filtrer',
					closeButton: 'Cancelar'
				}
			},
			adminPopin: {
				title: 'Filtros administrador',
				description: 'Aquí puede filtrar la información reservada para los administradores, como el estado del contenido, el corresponsal, la fecha de creación, la fecha de entrega, la fecha de publicación y mucho más.',
				fields: {
					adminFilter: 'Filtros de administrador'
				}
			},
			correspondantPopin: {
				title: 'Filtros de corresponsal',
				description: 'Puede filtrar aquí información reservada para corresponsales como el estado del contenido, contribuyente y mucho más. Cuando se aplica uno de los filtros aquí, la búsqueda se llevará a cabo solo en los contenidos que coincida.',
				fields: {
					correspondantFilter: 'Filtros de corresponsal'
				},
				typeField: {}
			},
			adminCorrespondantPopin: {
				errors:{
					date2Beforedate1 : 'Fechas inválidas'
				},
				fields: {
					status: 'Estado del contenido',
					contributor: 'Contribuyente',
					dateCreation: 'Fecha de creación',
					dateSoumission: 'Fecha de entrega',
					datePublication: 'Fecha de publicación',
					publierPar: 'Administrador que publicó el contenido',
					dateLastModif: 'Fecha de la última modificación',
					modifierPar: 'Usuario que modificó el contenido por última vez',
					dateMasqued: 'Fecha de retiro',
					masquerPar: 'Administrador que eliminó el contenido'
				},
				radioGroup: {
					after: 'Después de ',
					at: 'El ',
					before: 'Antes del ',
					between: 'Entre '
				},
				appliedFilters: 'Filtros aplicados :',
				emptyStateFilters: 'Aqui los filtros adicionales aplicados aparecerán',
				cardTitle: {
					status: 'Estado',
					contributor: 'Contribuyente',
					dateCreation: 'Creado',
					dateSoumission: 'Entregado',
					datePublication: 'Publicado',
					publierPar: 'Publicado por',
					dateLastModif: 'Ultimo cambio',
					modifierPar: 'modificar por',
					dateMasqued: 'Eliminado',
					masquerPar: 'Oculto por'
				},
				filterDateBetween: 'Entre el {dateDebut} y el {dateFin}'
			},
			share: {
				title: 'Compartir la búsqueda',
				description: 'Colocar las direcciones de correo electrónico de los destinatarios separados por un ";" para que puedan acceder a la búsqueda que ha realizado',
				form: {
					email: 'correo electrónico de los destinatarios *',
					commentaire: 'Mensaje adicional'
				},
				success: 'Su búsqueda ha sido bien compartida'
			},
			export: {
				sent: 'Su búsqueda está siendo exportada. Recibirá un correo electrónico cuando el documento esté disponible.',
				title: 'Exportar la tabla de resultados',
				description: 'Está a punto de exportar su tabla de resultados de búsqueda.  Aquí puede seleccionar las diferentes columnas que desea que aparezcan en su tabla y ordenarlas según sus necesidades.',
				selection: 'Selección de columnas',
				selected: 'Columnas seleccionadas',
				default: 'Columnas predeterminadas',
				add: 'Añadir',
				remove: 'Remover',
				placeholder: 'Columnas para mostrar',
				send: 'Exportar la tabla'
			},
			notFound: 'Ninguna búsqueda corresponde al ID señalado',
			addToFavorite: {
				title: 'Edición de una búsqueda guardada',
				form: {
					title: "Título de la búsqueda",
					notification: "Notificación semanal"
				}
			}
		},
		card: {
			created: 'Creado el : ',
			contributor: 'Contribuyente : ',
			modified: 'Actualizado el  : ',
			modifiedBy: 'Actualizado por : ',
			submit: 'Presentado el  : ',
			submitBy: 'Presentado por : ',
			validated: 'Validado el : ',
			published: 'Publicado el : ',
			publishedBy: 'Publicado por : ',
			masked: 'Ocultado el : ',
			maskedBy: 'Ocultado por : ',
			toDelete: 'Solicitud para eliminación el: ',
			toDeleteBy: 'Solicitud para eliminación de : ',
			toMask: 'Solicitud oculta el: ',
			toMaskBy: 'Solicitud oculta de : '
		},
		newDocumentPage: {
			propositionCommercial: {
				titre: 'Propuestas comerciales',
				description: 'El contenido de tipo Propuestas Comerciales permite compartir información y documentos de una licitacion. Algunos datos pueden ser declarados confidenciales y, por lo tanto, no visibles para la mayoría de los usuarios de Tender Box..',
				libelleLien: 'AÑADIR UNA PROPUESTA COMERCIAL'
			},
			savoirFaire: {
				titre: 'Know-How',
				description: 'El contenido “Know-How” permite compartir información específica relacionada con el Know-How  de Veolia, que se puede reutilizar en una nueva propuesta comercial, en un comunicado de prensa....',
				libelleLien: 'AÑADIR UN KNOW-HOW'
			},
			reference: {
				titre: 'Referencias',
				description: 'El contenido de tipo de referencia permite compartir datos comerciales y técnicos en cuanto los proyectos de Veolia. Algunos datos pueden declararse confidenciales y, por lo tanto, no son visibles para la mayoría de los usuarios de Tender Box',
				libelleLien: 'AÑADIR UNA REFERENCIA'
			}
		},
		submittingInfo: 'Debido a una restricción de Google en el proceso de copia, la descarga de carpetas y archivos puede tardar varios minutos. No cierre esta pestaña mientras graba.',
		saveSuccess: 'Información guardada. La actualización de este registro y la visibilidad en Tender Box puede llevar algún tiempo dependiendo de la cantidad y el tamaño de los documentos adjuntos.',
		newContent: 'Nuevo contenido',
		editContent: 'Modificación del contenido',
		retour: 'Regresar',
		saveRequiredPublication: 'Se requiere el registro para cambiar de estado',
		saveRequired: 'Se requiere el registro para cambiar de idioma',
		errorField: 'El campo "{fieldName}" se debe completar correctamente',
		globalReport: {
			tooltip: 'Actualización del archivo',
			popin: {
				title: 'Actualización del archivo',
				details: 'Ciertos datos del archivo están relacionados con el “Data Lake Global Report”de Veolia. Está a punto de actualizar estos campos con los datos actuales del “Global Report”, lo que sobrescribirá los valores ingresados ​​previamente en estos campos.',
				confirm: 'Actualizar'
			},
			success: 'El archivo ha sido actualizado'
		},
		entete: {
			title: 'Titulo',
			zone: 'Zona',
			language: 'Idioma de origen',
			contributor: 'Contribuyente',
			commentaire: 'Comentarios para el equipo Tender Box (no difundido)'
		},
		section: {
			defaultTitle: 'Título de la sección',
			defaultSubtitle: 'Subtítulos de la sección',
			switch: 'Marque esta sección como completada',
			deleteTitle: 'Suprimir sección duplicada',
			deleteMessage: 'Confirma usted la eliminación de esta sección duplicada ?'
		},
		field: {
			confidentiable: 'Datos confidenciales',
			libelleLink: 'Texto exacto',
			urlLink: 'URL',
			defaultValueInfo: 'Valor de referencia :',
			noValueInGR: 'No hay datos disponibles para este campo.',
			drive: {
				formPlaceHolder : "Buscar en drive",
				open: 'Abrir mi Drive',
				selectFiles: 'Seleccione los archivos de su drive que corresponden',
				infoFolder: 'Solo se importarán los primeros cinco niveles de una carpeta. No se importarán subcarpetas y archivos a partir del quinto nivel. El tamaño máximo de un archivo importable es de 50 MB (sin límite de tamaño en archivos de video).',
				prefixFolder: 'Carpeta :',
				errorRights: '{nomFichier} no cargado (derechos insuficientes).',
				errorSize: '{nomFichier} no cargado (archivo superior a 50MB).',
				errorGlobal: '{nomFichier} no cargado (Se ha producido un error).',
				uploading: '- Respaldo en proceso ...'
			},
			duns:{
				noresult:"No se han encontrado resultados",
				errorApi:"Error al llamar a la API de Duns",
				dunsLabelName:"nombre de empresa",
				dunsGlobalLabelName:"Empresa matriz (mundo)",
				dunsCountryLabelName:"Empresa matriz (país)",
				searchLink:"¿Necesita ayuda para encontrar un código DUNS?"
			}
		},
		folderPopin: {
			title: 'Composición de los archivos del campo "{fieldName}"',
			emptyFolder: 'La carpeta esta vacia',
			emptySearch: 'Ningún documento coincide con la búsqueda'
		},
		statusResponse: {
			error: 'No tiene autorización para realizar esta acción',
			refus: 'La solicitud ha sido denegada.',
			A_VALIDER: 'El contenido ha sido enviado con éxito',
			VALIDE: 'El contenido ha sido validado',
			PUBLIE: 'El contenido ha sido publicado',
			MASQUE: 'El contenido ha sido eliminado',
			SUPPRIME: 'El contenido se ha eliminado correctamente.',
			A_SUPPRIMER: 'El contenido ha sido sometido correctamente para eliminación.',
			A_MASQUER: 'El contenido ha sido sometido correctamente para ocultación .'
		},
		button: {
			soumettre: 'Enviar',
			valider: 'Validar',
			publier: 'Publicar',
			retirer: 'Eliminar'
		},
		menuConsultation: {
			share: 'Compartir',
			save: 'Guardar',
			contribute: 'Contribuir',
			exportFollow: 'Exportar para seguimiento'
		},
		partage: {
			title: 'Compartir el contenido',
			ask: '¿Desea compartir este contenido para consulta o contribución?',
			description: 'Ingrese las direcciones de correo electrónico de los destinatarios separados por un ";" para que reciban el enlace del contenido. ',
			form: {
				contribution: 'Compartir por contribución',
				consultation: 'Compartir por consulta',
				email: 'Correos electrónicos de los destinatarios *',
				commentaire: 'Mensaje adicional'
			},
			success: 'El contenido se ha compartido con éxito',
			close: 'Cerrar',
			send: 'Enviar'
		},
		translate: {
			title: 'Traducción automática',
			ask: 'Seleccione en qué idioma desea realizar una traducción automática.',
			description: 'La traducción automática solo se realizará para los campos que se dejan en blanco en los idiomas seleccionados y el usuario siempre podrá modificarlos.',
			close: 'Cancelar',
			send: 'Traducir'
		},
		suivi: {
			success: 'La exportación está en curso, recibirá un correo electrónico con el enlace para acceder al archivo.'
		},
		masquerSupprimerDoc: {
			popin: {
				title: 'Solicitud de eliminación de contenido',
				detailsBrouillonOrToValidate: 'Como este contenido aún no esta publicado, solo se puede eliminar de forma permanente. ¿Desea eliminarlo?',
				titleAdmin: 'Quitar el contenido ',
				details: '¿Desea pedir una solicitud para ocultar este contenido de Tender Box o eliminarlo de forma permanente?',
				detailsAdmin: '¿Desea pedir una solicitud para ocultar este contenido de Tender Box o eliminarlo de forma permanente?',
				detailsMsg: 'Puede agregar un mensaje al administrador.',
				placeholder: 'Mensaje adicional (250 caracteres máx.)*',
				warningSuppression: 'Advertencia: El borrado es irreversible',
				demandExistMasque: 'Un usuario quiere ocultar este registro.',
				demandExistSuppression: 'Un usuario quiere eliminar esta ficha.',
				messageUserForAdmin: 'Mensaje del usuario: {mensaje}',
				radioGroup: {
					retrait: 'Ocular el contenido',
					suppression: 'Eliminar definitivamente',
					rollBackToPublie: 'Cancelar la solicitud actual'
				}
			},
			snackbar: {
				success: 'Solicitud de retiro tenida en cuenta',
				error: 'Se ha producido un error'
			}
		}
	},
	contact: {
		title: 'Póngase en contacto con el equipo de Tender Box',
		validation: {
			message: 'Su mensaje ha sido enviado con éxito, el equipo de Tender Box le responderá en el menos tiempo posible'
		},
		field: {
			sujet: {
				label: 'Tema *',
				placeholder: 'Seleccione el tema de su mensaje'
			},
			objet: 'Objeto *',
			message: 'Mensaje *'
		}
	},
	enums: {
		langue: {
			fr: 'Francés',
			en: 'Inglés',
			es: 'Español',
			pl: 'Polaco'
		},
		documentType: {
			REFERENCE: 'Referencias',
			PROPOSITION_COMMERCIALE: 'Propuestas comerciales',
			SAVOIR_FAIRE: 'Know-How'
		},
		profil: {
			ROLE_VISITEUR: 'Visitante',
			ROLE_MEMBRE: 'Miembro',
			ROLE_CORRESPONDANT: 'Corresponsal',
			ROLE_ADMIN: 'Administrador'
		},
		documentStatus: {
			BROUILLON: 'Borrador',
			A_VALIDER: 'A validar',
			VALIDE: 'Validado',
			PUBLIE: 'Publicado',
			MASQUE: 'Ocultado',
			A_SUPPRIMER: 'A borrar',
			A_MASQUER: 'A ocultar'
		},
		documentStatusSummary: {
			BROUILLON: '(borrador)',
			A_VALIDER: '(a validar)',
			VALIDE: '(Validado)',
			PUBLIE: '(Publicado)',
			MASQUE: '(Ocultado)',
			A_SUPPRIMER: '(A borrar)',
			A_MASQUER: '(A ocultar)',
			SUPPRIME: 'Eliminado'
		},
		documentStatusContributions: {
			BROUILLON: 'Creado el',
			A_VALIDER: 'Presentado el',
			VALIDE: 'Validado el',
			PUBLIE: 'Publicado el',
			MASQUE: 'Eliminado de la publicación el ',
			A_SUPPRIMER: '[SUP] Enviado el',
			A_MASQUER: '[MASK] Enviado el'
		},
		field: {
			TEXT: 'Texto',
			TEXT_MULTILINE: 'Texto multilínea',
			SELECT: 'Seleccione',
			MULTI_SELECT: 'Multi selección',
			NUMBER: 'Número',
			NUMBER_UNIT: 'Numéro y unidad',
			AMOUNT: 'Importe',
			DATE: 'Fechas',
			FILE: 'Archivo',
			LINK: 'Enlace',
			LINK_PROPOSITION: 'Enlace propuesta comercial',
			TABLE: 'Tabla',
			DUNS: 'TODO-ANG : Code Duns'
		},
		withAttachment:{
			CASE_STUDY: 'Caso de éxitos',
			CERTIFICATE: 'Certificado'
		},
		internalExternal: {
			INTERNAL: 'Interno',
			EXTERNAL: 'Externo'
		}
	},
	modificationUser: {
		title: 'Usuario : ',
		titleCompte: 'Mi cuenta',
		retour: 'Regresar a la busqueda',
		infoVisiteur: 'Como visitante, tiene acceso limitado a Tender Box.\n' +
			'Un miembro tiene acceso a muchas funciones adicionales, como :\n' +
			'- Mejorar el contenido de su área aportando a Tender Box\n' +
			'- Compartir sus criterios de búsqueda\n' +
			'- Crear su favoritos.\n',
		btnAsk: 'Solicitar un acceso',
		form: {
			titlePart: 'Preferencias',
			nom: 'Apellido *',
			prenom: 'Nombre *',
			email: 'Correos electrónicos *',
			zone: 'Zona *',
			zoneVisiteur: 'Compruebe que esta país seleccionada es la suya. Una vez que se haya realizado su solicitud de acceso, no podrá modificarla y sólo un administrador podrá editarla',
			profil: 'Perfil *',
			FI_COUNTRY: 'País',
			FI_PRE_CLIENT_MARKET: 'Mercado',
			FI_SEGMENTS: 'Business Segment',
			FI_PRE_CLIENT_SECTOR: 'Sector',
			FI_SUBSEGMENT: 'Sub-segmento',
			paysOrigine: 'País de origen *',
			langue: 'Idiomas *',
			devise: 'Moneda *',
			su: 'Sistema de unidad *',
			paramGestion: 'Alcance de gestión',
			paramSubElement: 'Gestión del Facilitador',
			error: {
				mandatory: 'Este campo debe ser completado'
			}
		},
		backHome: 'Regresar a la página de inicio',
		askTitle: 'Solicitud de acceso',
		askMessage: 'Su solicitud ha sido registrada. Recibirá una notificación por correo electrónico una vez que su corresponsal haya validado o denegado el acceso.',
		popin: {
			title: 'Modificación del perfil y de sus preferencias',
			message: 'Confirme los cambios realizados en el perfil de ',
			success: 'El usuario ha sido cambiado con éxito',
			error: 'Se ha producido un error al registrar al usuario'
		}
	},
	accueil: {
		propositionCommerciale: {
			titre: 'Propuestas commerciales',
			description: 'Las Propuestas Comerciales son todos los documentos que se le han entregado al cliente durante un proceso de licitación.<br /><br />' +
				'Entre otras cosas, podrás compartir y descargar notas técnicas o también resúmenes para la elaboración de licitaciones.'
		},
		savoirFaire: {
			titre: 'Know-Hows',
			description: 'Los Know-Hows son partes estandarizadas de una propuesta que resalta un tema específico. Pueden ser reutilizados en la preparación de licitaciones.<br /><br />' +
				'Podriás compartir y descargar diferentes temas como seguridad y salud, gestión de activos, presentación de la organización transversal...'
		},
		reference: {
			titre: 'Referencias',
			description: 'Las referencias contienen información contractual, técnica y financiera sobre los contratos ganados por Veolia.<br /><br />' +
				'Podriás compartir y descargar casos de éxito, certificados cliente y también muchos indicadores técnicos.',
			button: 'Solamente mostrar las referencias con casos de éxito'
		},
		disponible: 'Disponibles en Tender Box',
		publication: 'Publicados este mes',
		contenuAValider: {
			titre: 'Contenidos a validar',
			description: 'Aquí encontrará los contenidos en espera de validación enviados por los miembros de Tender Box de su área',
			emptyTitre: 'No tiene usted ninguno contenido para validar…',
			emptyDescription: 'Aquí encontrará los contenidos en espera de validación enviados por los miembros de Tender Box de su área',
			bouton: 'Ver los contenidos'
		},
		contenuAPublier: {
			titre: 'Contenidos a publicar',
			description: 'Estos contenidos fueron presentados por los miembros de Tender Box incluyendo todas las áreas combinadas. Están esperando la validación para su publicación.',
			emptyTitre: 'No tiene usted ninguno contenido a publicar',
			emptyDescription: 'Aquí encontrará el número de contenidos presentados por los miembros de Tender Box incluyendo todas las áreas combinadas, es espera de validación para su publicación.',
			bouton: 'Ver los contenidos'
		},
		accesAValider: {
			titre: 'Solicitud de acceso a validar',
			description: 'Estas solicitudes fueron realizadas por usuarios de su área. Valide estas solicitudes para permitirles agregar contenido y usar Tender Box',
			emptyTitre: 'No tiene usted ninguno contenido a publicar',
			emptyDescription: 'Aquí encontrará la cantidad de solicitudes realizadas en espera de validación por los visitantes de Tender Box para su área',
			bouton: 'Ver las solicitudes'
		},
		accesAValiderAdmin: {
			titre: 'Solicitud de acceso a validar',
			description: 'Estas solicitudes fueron realizadas por usuarios visitantes de Tender box, todas las áreas combinadas.  Están esperando la validación para su publicación.',
			emptyTitre: 'No tiene usted ninguna solicitud a validar…',
			emptyDescription: 'Aquí encontrará la cantidad de solicitudes realizadas por los visitantes de Tender Box para todas área incluidas y en espera de validación',
			bouton: 'Ver las solicitudes'
		},
		top: {
			titre: 'Top 10 de los contenidos de Tender Box',
			description: 'Lista de los 10 contenidos favoritos de los usuarios'
		},
		mesContributions: {
			titre: 'Mis contribuciones',
			description: 'Todos los contenidos en los que soy colaborador',
			add: 'Añadir un contenido',
			empty: 'No tiene usted ninguna contribución'
		},
		libelleLien: {
			presentation: 'Más información',
			contact: 'Nuevo mensaje',
			correspondant: 'Buscar',
			visiteur: 'Solicitar acceso'
		}
	},
	parametrage: {
		typeContenu: {
			PROPOSITION_COMMERCIALE: 'Propuestas comerciales',
			SAVOIR_FAIRE: 'Conocimientos',
			REFERENCE: 'Referencias'
		},
		plan: 'Plan',
		detail: 'Detalle',
		section: {
			defaultTitle: 'Título de la sección',
			type: {
				FI: 'Ficha de identidad',
				RUBRIQUE: 'Sección',
				STANDARD: 'Estándar',
				DOCUMENT: 'Documento'
			},
			level: 'Niveau {level}',
			form: {
				REFERENCE: 'Referencias : ',
				new: 'Nueva sección de nivel 1',
				title: 'Nueva sección',
				parent: 'sección principal *',
				name: {
					en: 'Nombre de la sección (Inglés) *',
					fr: 'Nombre de la sección (Franés) *',
					es: 'Nombre de la sección (Español) *',
					pl: 'Nombre de la sección (Polaco) *'
				},
				type: 'Tipo de sección  *',
				titleCode: 'Código de campo que afecta al título',
				after: 'La sección se muestra después de la sección. *',
				first: 'La sección se muestra en primer lugar',
				visibility: 'La visibilidad de la sección está condicionada por un valor',
				sectionRegroupement: 'ANG - La section est une rubrique thématique de regroupement',
				reference: 'Referencia de los datos que condicionan la visibilidad',
				code: 'Código de valor que condiciona la visibilidad',
				publier: 'Publicar la sección',
				traduction: 'Traducción'
			},
			createsuccess: 'Nueva sección creada con éxito',
			editsuccess: 'Sección modificada con éxito',
			delete: {
				title: 'Suprimir la sección',
				ask: 'Estás seguro de que deseas eliminar esta sección ?',
				success: 'Sección eliminada con éxito',
				error: {
					child: 'No se puede eliminar porque la sección no está vacía.',
					fi: 'No se puede eliminar una Tarjeta de Identidad',
					generic: 'Se produjo un error al eliminar la sección'
				}
			},
			error: {
				isNotEmpty: 'La despublicación no es posible porque la sección contiene datos / secciones no despublicadas',
				parentNotPublished: 'la publicacion es imposible porque la sección principal es despublicada'
			}
		},
		field: {
			defaultTitle: 'Título del campo'
		},
		btnSection: 'Nueva sección',
		btnField: 'Nuevos datos',
		btnMajSearch: 'Actualizar la búsqueda',
		majSearchSuccess: 'La actualización de búsqueda está en progreso ',
		updateOrder: {
			success: 'La posición de los datos en la sección ha sido actualizada'
		},
		deleteField: {
			popin: {
				title: 'Suprimir el dato {name}',
				content: 'Confirma la eliminación del dato {name} ?'
			},
			error: {
				isReferenced: 'No se puede eliminar porque la sección no está referenciada por los datos siguientes:<br />{references}',
				generic: 'Se ha producido un error al eliminar los datos.'
			}
		},
		donneeForm: {
			newTitle: 'Nuevos datos',
			fields: {
				sectionParent: 'Sección principal',
				nomDonnee: 'Nombre de los datos ({langue})',
				reference: 'Referencia de los datos',
				nameBigQuery: 'Referencia de columna en la exportación BQ',
				type: 'Tipo de datos',
				visibility: {
					check: 'La visibilidad de los datos está condicionada por un valor',
					reference: 'la referencia de los datos condicionan la visibilidad',
					code: 'el Código de valor condiciona la visibilidad'
				},
				defaut: 'Valor por defecto',
				confidentiable: 'El usuario puede declarar que los datos son confidenciales',
				donneeAvancee: 'ANG - Cette donnée est une donnée avancée',
				help: 'Texto de ayuda para el colaborador ({langue}).',
				publier: 'Publicar los datos',
				select: {
					source: 'Lista de valores de la fuente',
					reference: 'El contenido de esa lista depende de otros datos',
					referenceParent: 'Referencia de datos de principales'
				},
				unite: {
					source: 'Unidad SI asociada',
					default: 'Unidad por defecto'
				},
				table: {
					columnName: 'Número en la columna ({langue})',
					popin: {
						addTitle: 'Añadir una columna',
						editTitle: 'Editar una columna'
					}
				}
			},
			fieldTypes: {
				TEXT: 'Texto',
				TEXT_MULTILINE: 'Texto multilínea',
				SELECT: 'Lista de selección simple',
				MULTI_SELECT: 'Lista de selección múltiple',
				NUMBER: 'Número',
				NUMBER_UNIT: 'Número y unidad',
				AMOUNT: 'Importe',
				DATE: 'Fecha',
				FILE: 'Documento',
				LINK: 'Enlace',
				LINK_PROPOSITION: 'Enlace con otro contenido',
				TABLE: 'Tabla',
				DUNS: 'TODO-ANG : Code Duns'
			},
			error: {
				isReferenced: 'la despublicación no es possible, porque los datos están referenciados por los siguientes datos:<br />{references}',
				parentNotPublished: 'La publicación es imposible, porque la sección principal está despublicada',
				referenceAlreadyExist: 'Ya existe la siguiente referencia de datos: {referencia}',
				tableReferenceIdentical: 'La tabla tiene referencias idénticas'
			}
		},
		traduction: 'Traducción'
	},
	additionalFilters: {
		title: 'Filtros adicionales',
		researchSections: 'Secciones de búsqueda',
		researchFields: 'Campos de búsqueda',
		newSection: 'Nueva sección',
		updateSection: 'Editar la sección',
		newField: 'Nuevo campo de búsqueda',
		updateField: 'Modificar un campo de una búsqueda',
		reset: 'Cancelar',
		save: 'Guardar',
		addField: 'Añadir un campo',
		form: {
			name: 'Nombre de la sección (inglés) *',
			subSegments: 'Valor(es) del subsegmento que condiciona la visibilidad',
			publishedSection: 'Publicar la sección',
			publishedField: 'Publicarlo',
			nameFr: 'Nombre de la sección (francés) *',
			nameEs: 'Nombre de la sección (español) *',
			namePl: 'Nombre de la sección (polaco) *',
			reference: 'Referencia del campo',
			alreadyUsedReference: 'Este código es utilizado en una sección',
			referenceNotFound: 'Referencia no encontrada'
		},
		add: {
			snackSuccess: 'Modificaciones guardadas'
		}
	},
	valueList: {
		recherche: 'Buscar',
		valeurs: 'Valor',
		form: {
			name: 'Nombre',
			shortcut: 'Código',
			description: 'Descripción'
		},
		entries: {
			valeurs: 'Valor',
			actif: 'Activo',
			inactif: 'Inactivo'
		},
		popin: {
			add: 'Agregar un valor',
			edit: 'Editar un valor',
			code: 'Código',
			inactif: 'Inactivo',
			langue: 'Etiqueta {codeLang}'
		}
	}
})
